export default __webpack_public_path__ + "static/media/onboardingAside.78ee7f28.png";